/**
 * Not rebuilt yet: the real page from before agents, shown inside the new frame so nothing is missing
 * while its new form is wired to live data.
 */
import { WorkersPage } from '../components/workers/WorkersPage'

export const WorkersBar = () => null
export function WorkersView() {
  return (
    <div className="lb-legacy min-h-full">
      <WorkersPage />
    </div>
  )
}
